import React, { useEffect } from "react";
import { useTransactionModel } from "./transactionModel";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { YhBox } from "@/components/YhBox";
import { TransactionDataTable } from "./DataTable";

export const TransactionDataBox = () => {
    const {
        // dataSource,
        transactionAmount,
        loadData,
        // selectedRowKeys,
        // setSelectedData,
    } = useTransactionModel();

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [])

    // useEffect(() => {
    //     let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
    //     const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
    //     setSelectedData(selectedData)
    // }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "欠款",
            value: transactionAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
    ]


    return (
        <>
            <YhBox title={"往来交易记录"} descriptions={desc}>
                <TransactionDataTable />
            </YhBox>
        </>
    )
}